import fetchUsers from '../Services/fetchUsers'

export default () => (dispatch) => {

  dispatch(fetchUsers())

}
